import { render, staticRenderFns } from "./PromotionFormV2.vue?vue&type=template&id=73d9c217&scoped=true&"
import script from "./PromotionFormV2.vue?vue&type=script&lang=js&"
export * from "./PromotionFormV2.vue?vue&type=script&lang=js&"
import style0 from "./PromotionFormV2.vue?vue&type=style&index=0&id=73d9c217&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d9c217",
  null
  
)

export default component.exports